'use client';

import React from 'react';
import { config } from '@/src/config';
import { GoogleLogoIcon } from '../icons';
import styles from './Auth.module.css';

interface GoogleSignInButtonProps {
  label: string;
  referral?: string;
  disabled?: boolean;
}

const GOOGLE_AUTH_ENDPOINT = 'https://accounts.google.com/o/oauth2/v2/auth';
const GOOGLE_SCOPES = 'openid email profile';

const GoogleSignInButton: React.FC<GoogleSignInButtonProps> = ({ label, referral, disabled }) => {
  if (!config.GOOGLE_CLIENT_ID) return null;

  const handleClick = () => {
    const clientId = config.GOOGLE_CLIENT_ID;
    const redirectUri = `${window.location.origin}/google`;
    const params = new URLSearchParams({
      client_id: clientId,
      redirect_uri: redirectUri,
      response_type: 'code',
      scope: GOOGLE_SCOPES,
      access_type: 'online',
      prompt: 'select_account',
    });

    if (referral) {
      params.set('state', encodeURIComponent(JSON.stringify({ referral })));
    }

    window.location.href = `${GOOGLE_AUTH_ENDPOINT}?${params.toString()}`;
  };

  return (
    <button
      type="button"
      className={styles.googleButton}
      onClick={handleClick}
      disabled={disabled}
      aria-label={label}
    >
      <GoogleLogoIcon />
      <span>{label}</span>
    </button>
  );
};

export default GoogleSignInButton;
